import React from 'react';
import { ReactComponent as ReturnPercentage } from 'assets/icons/project-return-money-green.svg';
import { ReactComponent as Loan } from 'assets/icons/project-hand-money-green.svg';
import { ReactComponent as Frequency } from 'assets/icons/certification-green.svg';
import { ReactComponent as Money } from 'assets/icons/project-money-green.svg';
import { ReactComponent as Time } from 'assets/icons/project-watch-money-green.svg';
import { ReactComponent as Document } from 'assets/icons/document-money-green.svg';
import { formatNumber } from 'util/formatNumber';
import {
  colorByProjectType,
  stocksTypeType,
  issuanceTypes,
} from 'types/projectType';
import { calculatePercentage } from 'util/percent';
import { useMediaQuery } from 'hooks';
import { Grid } from '@material-ui/core';
import InfoCard from 'components/InfoCard';
import { colors } from 'globalStyle';

function StocksConditions({
  percentageEquity,
  numberNodes,
  nodePerPackage,
  issuanceType,
  annualSales,
  growthProjectionPercentage,
  growthProjectionDescription,
  stockTypeDescription,
  valuationDescription,
  annualSalesDescription,
  stockType,
  nodeValue,
  maxAmount,
  projectType,
  currencyIso,
  resourcesGathering,
  valuation,
  styles,
  color,
}) {
  const isDesktop = useMediaQuery(1023);
  const conditionsStockProject = [
    {
      xs: isDesktop && 4,
      image: <ReturnPercentage color={color || colorByProjectType[projectType]} />,
      style: styles.primaryCard,
      title: `${
        issuanceType === issuanceTypes.INDIVIDUAL
          ? formatNumber(nodeValue, null, currencyIso)
          : formatNumber(nodeValue * nodePerPackage, null, currencyIso)
      }`,
      subtitle: `${
        issuanceType === issuanceTypes.INDIVIDUAL
          ? 'Precio por la acción'
          : 'Valor mínimo de inversión'
      }`,
      imageWidth: isDesktop ? '50px' : '30px',
      description: `${
        issuanceType === issuanceTypes.INDIVIDUAL
          ? 'Corresponde al valor más pequeño que puedes comprar.'
          : 'Corresponde al grupo de acciones más pequeño que puedes comprar.'
      }`,
    },
    {
      xs: isDesktop && 4,
      image: <Money color={color || colorByProjectType[projectType]} />,
      style: styles.primaryCard,
      title: formatNumber(maxAmount, null, currencyIso),
      subtitle: 'Monto a recaudar',
      imageWidth: isDesktop ? '45px' : '28px',
      description:
              'La cantidad total de dinero que la empresa busca recaudar en la emisión de acciones.',
    },
    {
      xs: isDesktop && 4,
      image: <Loan color={color || colorByProjectType[projectType]} />,
      style: styles.primaryCard,
      title: stocksTypeType[stockType],
      subtitle: 'Tipo de acción',
      imageWidth: isDesktop ? '50px' : '30px',
      description: stockTypeDescription,
    },
    {
      xs: isDesktop && 4,
      image:
              issuanceType === issuanceTypes.INDIVIDUAL ? (
                <Time color={color || colorByProjectType[projectType]} />
              ) : (
                <Money color={color || colorByProjectType[projectType]} />
              ),
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: (
        <>
          {issuanceType === issuanceTypes.INDIVIDUAL
            ? resourcesGathering
            : nodePerPackage}
        </>
      ),
      subtitle: `${
        issuanceType === issuanceTypes.INDIVIDUAL
          ? 'Recolección de recursos'
          : 'Número de acciones por paquete'
      }`,
      imageWidth: isDesktop ? '50px' : '30px',
      description:
            issuanceType === issuanceTypes.INDIVIDUAL
              ? 'Tiempo durante el cual se planea hacer la recolección de los recursos para la financiación.'
              : 'Cantidad de Acciones que tiene cada uno de los paquetes mínimos de inversión',
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image: <Money color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: numberNodes,
      subtitle: 'Acciones de la ronda',
      imageWidth: isDesktop ? '50px' : '30px',
      description: 'Cantidad de acciones que la empresa pone en venta',
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image: <Document color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: formatNumber(valuation, null, currencyIso),
      subtitle: 'Valorización de la empresa:',
      imageWidth: isDesktop ? '45px' : '28px',
      description: (
        <>
          {`${valuationDescription}`}
          <br />
          Este valor es proporcionado por la empresa, Bloom no tiene injerencia
          ni se hace responsible por este.
        </>
      ),
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image: <Document color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.secondaryCard : styles.primaryCard,
      title: `${calculatePercentage(percentageEquity)}%`,
      subtitle: 'Porcentaje de patrimonio',
      imageWidth: isDesktop ? '50px' : '30px',
      description:
              'Es el porcentaje del valor de la empresa que se pone a la venta en la emisión.',
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image: <Frequency color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: formatNumber(annualSales, null, currencyIso),
      subtitle: 'Ventas anuales',
      imageWidth: isDesktop ? '45px' : '28px',
      description: annualSalesDescription,
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
    {
      xs: isDesktop && 4,
      image: <Frequency color={color || colorByProjectType[projectType]} />,
      style: isDesktop ? styles.thirdCard : styles.primaryCard,
      title: `${calculatePercentage(growthProjectionPercentage)}%`,
      subtitle: 'Proyección de crecimiento',
      imageWidth: isDesktop ? '45px' : '28px',
      description: growthProjectionDescription,
      hoverDescription: true,
      colorByProjectType: colorByProjectType[projectType],
    },
  ];
  return (
    <Grid container spacing={isDesktop && 2} className={styles.root}>
      {conditionsStockProject?.map(
        ({
          xs,
          image,
          style,
          title,
          subtitle,
          imageWidth,
          description,
          hoverDescription,
        }) => (
          <Grid item xs={xs}>
            <InfoCard
              isDesktop={isDesktop}
              image={image}
              className={style}
              color={colors.GRAY_10}
              title={title}
              subtitle={subtitle}
              imageWidth={imageWidth}
              description={description}
              fullDescription
              centerDescription
              hoverDescription={hoverDescription && isDesktop}
              colorByProjectType={color || colorByProjectType[projectType]}
            />
          </Grid>
        ),
      )}
    </Grid>
  );
}

export default StocksConditions;
